import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiEndpoints } from "../../helpers/constants";
import { notifyAPIMessages } from "../../helpers/commonFunction";
import { Axios, authHeaders } from "../../helpers/axios";
import { reqToForceUserLogout } from "./userSlice";

export const reqToGetAdminCourseList = createAsyncThunk(
  apiEndpoints.courseList,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.courseList,
        data,
        authHeaders()
      );
      onSuccess?.(response);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetUserCourseList = createAsyncThunk(
  apiEndpoints.courseListUser,
  async ({ onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        apiEndpoints.courseListUser,
        authHeaders()
      );
      onSuccess?.(response);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToGetCourseModuleList = createAsyncThunk(
  apiEndpoints.courseModuleListUser,
  async ({ data, onSuccess, onFailure, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.courseModuleListUser,
        data,
        authHeaders()
      );
      onSuccess?.(response);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loader: false,
  error: "",
  courseList: [],
  userCourseList: [],
  courseModuleList: [],
};

const coursesSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ADMIN COURSE LIST
    builder
      .addCase(reqToGetAdminCourseList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetAdminCourseList.fulfilled, (state, action) => {
        state.loader = false;
        state.courseList = action.payload?.data;
      })
      .addCase(reqToGetAdminCourseList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.error;
        notifyAPIMessages(action.payload);
      });

    // USER COURSE LIST
    builder
      .addCase(reqToGetUserCourseList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetUserCourseList.fulfilled, (state, action) => {
        state.loader = false;
        state.userCourseList = action.payload?.data;
      })
      .addCase(reqToGetUserCourseList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.error;
        notifyAPIMessages(action.payload);
      });

    // COURSE MODULE LIST
    builder
      .addCase(reqToGetCourseModuleList.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToGetCourseModuleList.fulfilled, (state, action) => {
        state.loader = false;
        state.courseModuleList = action.payload?.data;
      })
      .addCase(reqToGetCourseModuleList.rejected, (state, action) => {
        state.loader = false;
        state.error = action.error;
        notifyAPIMessages(action.payload);
      });
  },
});

export default coursesSlice.reducer;
